import rpAPI from '../service/rpAPI.js';
import Globals from '../model/Globals.js';
import Tag from './Tag.js';

class User {
  

  constructor(data) {
    Object.assign(this, data);   

  } 

  numberOfOrders() {
    return this.orders ? this.orders.length : 0;
  }

  async initProfiles() {
    try {
    this.profiles = await rpAPI.getMyProfiles();
    }
    catch (error) {
      this.profiles = [];
    }
    this.profiles.forEach((profile) => {
      // take first letter from name and last name
      profile['age'] = new Date().getFullYear() - new Date(profile.date_of_birth).getFullYear();
      profile['key'] = profile.first_name.charAt(0) + profile.last_name.charAt(0) + profile['age'];
      profile['level'] = profile.level?.map(tag => tag?.tags_id?.id).filter(Boolean) || [];
      profile['selected'] = false;
    });
  }

  isInitialized() {
    return this.profiles !== undefined;
  }

  async getAllGroupsForProfile(profile) {
    try {
      const response = await rpAPI.getGroupsForProfile(profile.id);
      if (!response || response.length === 0) {
        return [];
      }
      return response.map(item => item.group.id);
    } catch (error) {
      console.error('Error fetching groups for profile:', error);
      throw error;
    }
  }



  async updateProfiles(newprofiles) {
    // sync profiles with the same id, copy it's name, last name and email, pesel, phone
    // the one witoout id will be added
    let self = this;
    newprofiles.forEach((profile) => {
      if (profile.id) {
        let profileToUpdate = self.profiles.find(p => p.id === profile.id);
        if (!profileToUpdate && profile.pesel) {
          profileToUpdate = self.profiles.find(p => p.pesel === profile.pesel);
        }
        if (profileToUpdate) {
          profileToUpdate.first_name = profile.first_name;
          profileToUpdate.last_name = profile.last_name;
          profileToUpdate.pesel = profile.pesel;
          profileToUpdate.nationality = profile.nationality;
          profileToUpdate.date_of_birth = profile.date_of_birth;
          profileToUpdate.gender = profile.gender;
          //  profileToUpdate.profile  this json structure I want to make sum of all profiles
          // how to merge two jsons in javascript
            profileToUpdate.profile = {
            ...profileToUpdate.profile,
            ...profile.profile
            };

            delete profileToUpdate.key;
            delete profileToUpdate.age;
            delete profileToUpdate.selected;
            delete profileToUpdate.level; // nie chcemy aktualizować poziomu umiejętności, bo to jest zarządzane przez tagi
            try {
              rpAPI.updateProfile(profileToUpdate.id, profileToUpdate);
            } catch (error) {
              console.log(error);
            }
        }
      } else {
        try { 
        rpAPI.createProfile({
          parent: this.id,
          ...profile
        });
        } catch (error) {
          console.log(error);
        }
      }
    });
  }

  
  defaultProfile() {
    if (this.profiles && this.profiles.length > 0) {
      return this.profiles[0];
    }
    return null;
  }

  displayName() {
    if (this.first_name && this.last_name) {
      return `${this.first_name} ${this.last_name}`;
    } else if (this.email && !this.isTemporaryEmail) {
      return this.email;
    } else if (this.phone) {
      return this.formatPhone(this.phone);
    }
    return '';
  }

  initials() {
    if (this.first_name && this.last_name) {
      return `${this.first_name.charAt(0)}${this.last_name.charAt(0)}`.toUpperCase();
    } else if (this.email && !this.isTemporaryEmail) {
      return this.email.substring(0, 2).toUpperCase();
    }
    return '';
  }

  isTemporaryEmail() {
      if (this.email) {
        const domain = Globals.EMAIL_DOMAIN;
        const emailDomain = this.email.split('@')[1];
        const emailPrefix = this.email.split('@')[0];
        return domain === emailDomain && emailPrefix == this.phone ;
      }
      return false;
    }


}


export default User;